<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
        :class="[{'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.patrimoine')">
            <b-input v-model="newCritereRecherche.lignesCommandeRegroupementLibelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.typeProduit')">
            <b-input v-model="newCritereRecherche.lignesCommandeLibelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.theme')">
            <qd-taginput
              v-model="newCritereRecherche.themes"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.dateBaf')">
            <div class="columns is-vcentered" >
              <b-datepicker show-week-number
                            class="column"
                            v-model="newCritereRecherche.datesBaf.dateDebut"
                            icon="calendar-today"
                            :editable="true"
                            position="is-bottom-right"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
              <span class="column is-1">{{$t('commandeBaf.filtre.au')}}</span>
              <b-datepicker show-week-number
                            class="column"
                            v-model="newCritereRecherche.datesBaf.dateFin"
                            icon="calendar-today"
                            :editable="true"
                            position="is-bottom-left"
                            :nearby-selectable-month-days="true">
              </b-datepicker>
            </div>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.quiBaf')">
            <b-autocomplete
              :open-on-focus="true"
              :data="userList"
              :value="userName"
              :loading="isFetching"
              field="decorator.nomPrenom"
              icon="magnify"
              @select="setQuiABaf"
              @input="getUser">
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.fournisseur')">
            <qd-taginput
              v-model="fournisseurSelected"
              :data="filteredFournisseur"
              autocomplete
              :allow-new="false"
              field="nomCommercial"
              icon="magnify"
              type="is-primary"
              @select="filteredFournisseur = []"
              @typing="getFilteredFournisseur">
              <template slot-scope="props">
                {{ props.option.nomWithAdresseAndCompteComptable }}
              </template>
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.annonceur')">
            <qd-taginput
              v-model="annonceurSelected"
              :data="filteredAnnonceur"
              autocomplete
              :allow-new="false"
              field="nomCommercial"
              icon="magnify"
              type="is-primary"
              @select="filteredAnnonceur = []"
              @typing="getFilteredAnnonceur">
              <template slot-scope="props">
                {{ props.option.nomWithAdresseAndCompteComptable }}
              </template>
              <template slot="empty">
                  {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.payeur')">
            <qd-taginput
              v-model="payeurSelected"
              :data="filteredPayeur"
              autocomplete
              :allow-new="false"
              field="nomCommercial"
              icon="magnify"
              type="is-primary"
              @select="filteredAnnonceur = []"
              @typing="getFilteredPayeur">
              <template slot-scope="props">
                {{ props.option.nomWithAdresseAndCompteComptable }}
              </template>
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.assistant')">
            <qd-taginput v-if="assistantTags"
                        v-model="assistantSelected"
                        :data="assistantTags"
                        autocomplete
                        open-on-focus
                        icon="magnify"
                        type="is-primary"
                        field="decorator.nomPrenom"
                        @typing="getFilteredAssistantTags"
                        @input="getAssistantTag">
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.baf')">
            <b-select v-model="newCritereRecherche.bonAFacturer">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.facturationFaite')">
            <b-select v-model="newCritereRecherche.facturationFaite">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('commandeBaf.filtre.aFacturer')">
            <b-select v-model="newCritereRecherche.aFacturer">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('commandeBaf.filtre.groupe')"
            dropdown="top"
            v-model="groupeSelected"
            :typologie="this.constantes.TYPOLOGIE_GROUPE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            :label="$t('commandeBaf.filtre.enseigne')"
            dropdown="top"
            v-model="enseigneSelected"
            :typologie="this.constantes.TYPOLOGIE_ENSEIGNE"
            :societeActiveId="this.societeActiveId">
          </query-tiers-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/tiers';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_TYPE_CLIENT,
  TYPOLOGIE_ENSEIGNE,
  TYPOLOGIE_GROUPE,
  TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import genererCritereRechercheBafCommande
  from '@/services/commande/criteresRecherche/genererCritereRechercheBafCommande';
import { SET_CRITERE } from '@/store/modules/bafCommande-mutation-type';
import queryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';

const CommandesBaf = createNamespacedHelpers('bafCommande');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'filtreEcheanceBaf',
  data() {
    return {
      errors: [],
      fournisseurSelected: [],
      filteredFournisseur: [],
      annonceurSelected: [],
      filteredAnnonceur: [],
      filteredPayeur: [],
      payeurSelected: [],
      assistantTags: [],
      assistantSelected: [],
      newCritereRecherche: null,
      userList: [],
      isFetching: false,
      userName: '',
      groupeSelected: [],
      enseigneSelected: [],
      constantes: {
        TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE,
      },
    };
  },
  components: {
    queryTiersTagInput,
    errorMsgComponent,
  },
  computed: {
    ...CommandesBaf.mapGetters({
      critereRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    usersActif() {
      return this.parametre(PARAMETRES_KEYS.utilisateur).filter(u => u.actif);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...CommandesBaf.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    getUser(text) {
      if (!text) return;
      try {
        this.isFetching = true;
        this.userList = this.usersActif
          .filter((user) => {
            return user.decorator.nomPrenom.toLowerCase().includes(text.toLowerCase());
          });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getFilteredFournisseur: debounce(async function getAfficheur(search) {
      this.filteredFournisseur = [];
      if (!search) return;
      try {
        const fournisseur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [],
              type: TIERS_TYPE_FOURNISSEUR,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        fournisseur.forEach((tiers) => {
          tiers.nomWithAdresseAndCompteComptable = tiers.code + ' - ' + tiers.nomCommercial;
          if (adressFullStringGetter(tiers.adressePostale, false) !== '') {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + adressFullStringGetter(tiers.adressePostale, false);
          }
          if (tiers.compteComptable) {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + tiers.compteComptable;
          }
        });
        this.filteredFournisseur = fournisseur.filter((fourni) => {
          return !this.fournisseurSelected.map(fournisseurSelected => fournisseurSelected.id)
            .includes(fourni.id);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredAnnonceur: debounce(async function getAnnonceur(search) {
      this.filteredAnnonceur = [];
      if (!search) return;
      try {
        const annonceur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [TIERS_SOUS_TYPE_AUCUN],
              type: TIERS_TYPE_CLIENT,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        annonceur.forEach((tiers) => {
          tiers.nomWithAdresseAndCompteComptable = tiers.code + ' - ' + tiers.nomCommercial;
          if (adressFullStringGetter(tiers.adressePostale, false) !== '') {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + adressFullStringGetter(tiers.adressePostale, false);
          }
          if (tiers.compteComptable) {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + tiers.compteComptable;
          }
        });
        this.filteredAnnonceur = annonceur.filter((tiersAnnonceur) => {
          return !this.annonceurSelected.map(annonceurSelected => annonceurSelected.id)
            .includes(tiersAnnonceur.id);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getFilteredPayeur: debounce(async function getAnnonceur(search) {
      this.filteredPayeur = [];
      if (!search) return;
      try {
        const payeur = (await getAll(
          {
            query: {
              auto: search,
              sousType: [TIERS_SOUS_TYPE_AUCUN],
              type: TIERS_TYPE_CLIENT,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items;
        payeur.forEach((tiers) => {
          tiers.nomWithAdresseAndCompteComptable = tiers.code + ' - ' + tiers.nomCommercial;
          if (adressFullStringGetter(tiers.adressePostale, false) !== '') {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + adressFullStringGetter(tiers.adressePostale, false);
          }
          if (tiers.compteComptable) {
            tiers.nomWithAdresseAndCompteComptable += ' - ' + tiers.compteComptable;
          }
        });
        this.filteredPayeur = payeur.filter((tiersPayeur) => {
          return !this.payeurSelected.map(payeurSelected => payeurSelected.id)
            .includes(tiersPayeur.id);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    getAssistantTag() {
      this.assistantTags = this.listeAssistantBase.filter((assistant) => {
        return !this.assistantSelected.map(c => c.id).includes(assistant.id);
      });
    },
    getFilteredAssistantTags(text) {
      this.getAssistantTag();
      this.assistantTags = this.assistantTags.filter((assistant) => {
        return assistant.decorator.nomPrenom.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    setQuiABaf(user) {
      if (!user) return;
      this.newCritereRecherche.quiABaf = user.id;
      this.userName = user.decorator.nomPrenom;
    },
    appliquerCritere() {
      this.errors = [];
      if (moment(this.newCritereRecherche.datesBaf.dateDebut)
        .isAfter(this.newCritereRecherche.datesBaf.dateFin)) {
        this.errors.push({
          message: 'commandeBaf.filtre.error.messageErrorDateBaf',
        });
        return;
      }
      this.newCritereRecherche.fournisseursId = this.fournisseurSelected;
      this.newCritereRecherche.annonceursId = this.annonceurSelected;
      this.newCritereRecherche.payeursId = this.payeurSelected;
      this.newCritereRecherche.groupeIds = this.groupeSelected;
      this.newCritereRecherche.enseigneIds = this.enseigneSelected;
      this.newCritereRecherche.assistantIds = this.assistantSelected.map((c) => {
        return c.id;
      });
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche');
    },
    viderCritere() {
      this.newCritereRecherche = genererCritereRechercheBafCommande();
      this.fournisseurSelected = [];
      this.userName = null;
      this.annonceurSelected = [];
      this.payeurSelected = [];
      this.assistantSelected = [];
      this.groupeSelected = [];
      this.enseigneSelected = [];
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRecherche);
        await this.loadParametreUtilisateur();
        this.fournisseurSelected = this.newCritereRecherche.fournisseursId;
        this.annonceurSelected = this.newCritereRecherche.annonceursId;
        this.payeurSelected = this.newCritereRecherche.payeursId;
        this.enseigneSelected = this.critereRecherche.enseigneIds;
        this.groupeSelected = this.critereRecherche.groupeIds;
        this.listeAssistantBase = this.usersActif
          .filter((user) => {
            return user.profil === ASSISTANT_COMMERCIAL;
          });
        this.userList = this.usersActif;
        if (this.newCritereRecherche.quiABaf) {
          this.userName = this.userList
            .find((user) => {
              return user.id === this.newCritereRecherche.quiABaf;
            }).decorator.nomPrenom;
        }
        this.assistantSelected = this.listeAssistantBase.filter((c) => {
          return this.newCritereRecherche.assistantIds.includes(c.id);
        });
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
